import React, { Component } from 'react';
import {
  Table,
  Tooltip,
} from 'antd';
import uuid from 'uuid/v4';
import i18n from '../../config/i18n';

const styles = {
  center: {
    display: 'flex',
    justifyContent: 'center',
  },
};

const columns = [
  {
    title: '',
    dataIndex: 'rowTitle',
    className: 'featuresHeader',
  },
  {
    title: '30 Day Trial',
    dataIndex: 'planA',
    className: 'featuresHeader',
  },
  {
    title: 'Guru Elite',
    dataIndex: 'planB',
    className: 'featuresHeader',
  },
  {
    title: 'Guru Pro',
    dataIndex: 'planC',
    className: 'featuresHeader',
  },
];

const rows = [
  {
    key: 0,
    rowTitle: 'Web App Portal',
    planA: '✓',
    planB: '✓',
    planC: '✓',
  },
  {
    key: 1,
    rowTitle: 'Mobile iOS App',
    planA: '✓',
    planB: '✓',
    planC: '✓',
  },
  {
    key: 2,
    addTooltipFields: ['rowTitle'],
    tooltipMessages: ['Contact us if you have growing crews in your group'],
    rowTitle: 'Team Size',
    planA: '≤ 5 members',
    planB: '≤ 10 members',
    planC: '≤ 20 members',
  },
  {
    key: 3,
    rowTitle: 'Number of Patients',
    planA: 'Unlimited',
    planB: 'Unlimited',
    planC: 'Unlimited',
  },
  {
    key: 4,
    addTooltipFields: ['rowTitle'],
    tooltipMessages: ['Contact us if you have growing demands'],
    rowTitle: 'Patient Referral btw Providers',
    planA: '≤ 5 referrals/mo',
    planB: '≤ 20 referrals/mo',
    planC: '≤ 100 referrals/mo',
  },
  {
    key: 5,
    rowTitle: 'HD Photos and Videos Upload',
    planA: 'Unlimited',
    planB: 'Unlimited',
    planC: 'Unlimited',
  },
  {
    key: 6,
    rowTitle: 'Military Grade 256-bits AES encryption',
    planA: '✓',
    planB: '✓',
    planC: '✓',
  },
  {
    key: 7,
    addTooltipFields: ['rowTitle'],
    tooltipMessages: [`Contact us for volume special deals. ${i18n.t(['subscription', 'FRATips'])}`],
    rowTitle: 'GuruGait™ - Fall Risk Assessment & Management***',
    planA: '≤ 5 assessments',
    planB: '≤ 10 assessments/mo',
    planC: '≤ 30 assessments/mo',
  },
  {
    key: 8,
    rowTitle: 'GuruChat™ - Secure Texting & Collaborations',
    planA: 'Unlimited',
    planB: 'Unlimited',
    planC: 'Unlimited',
  },
  {
    key: 9,
    addTooltipFields: ['rowTitle'],
    tooltipMessages: [`Contact us if you have growing demands. ${i18n.t(['subscription', 'chatTips'])}`],
    rowTitle: 'GuruChat™ - Televisit (Secure Video Call)****',
    planA: '3 sessions/mo',
    planB: '5 sessions/mo',
    planC: '20 sessions/mo',
  },
  {
    key: 10,
    addTooltipFields: ['rowTitle'],
    tooltipMessages: ['Limited seats only, sign up now to take advantage on this!'],
    rowTitle: 'Free Advertisement for Your Practice**',
    planA: '✓',
    planB: '✓',
    planC: '✓',
  },
  {
    key: 11,
    addTooltipFields: ['planB', 'planC'],
    tooltipMessages: ['Options for user to enable/disable', 'Options for user to enable/disable'],
    rowTitle: 'Remove Ad Banners',
    planA: '✗',
    planB: '✓*',
    planC: '✓*',
  },
  {
    key: 12,
    rowTitle: 'Export PDF Report (Fall Risk Assessment)',
    planA: '✗',
    planB: 'Unlimited',
    planC: 'Unlimited',
  },
  {
    key: 13,
    rowTitle: 'Member-Only DME Promotions (Orthopedic Bracings)',
    planA: '✗',
    planB: '✓',
    planC: '✓',
  },
];


class FeaturesView extends Component {
  formatTooltipMessage = message => message
    .split(/(Contact )us/i)
    .map(el => (
      <span key={uuid()}>
        {el}
        {el === 'Contact '
          ? <a href={`mailto:${i18n.t('iHealthCareEmail')}`}>us</a>
          : ''
        }
      </span>
    ));

  formatRows = inputRows => inputRows.map((el) => {
    if (el.addTooltipFields) {
      const newEl = { ...el };
      el.addTooltipFields.forEach((el2, j) => {
        newEl[el2] = (
          <Tooltip
            title={this.formatTooltipMessage(el.tooltipMessages[j])}
          >
            {el[el2]}
          </Tooltip>
        );
      });

      return newEl;
    }
    return el;
  });

  render() {
    return (
      <div>
        <Table
          ref={(input) => { this.table = input; }}
          bordered={false}
          columns={columns}
          dataSource={this.formatRows(rows)}
          pagination={false}
          title={() => (
            <div>
              <br />
              <h3 style={styles.center}>Compare Plans</h3>
            </div>
          )}
          footer={() => (
            <div className="featuresFooter">
              {'* : Options for user to enable/disable'}
              <br />
              {'**: Limited seats only, sign up now to take advantage on this!'}
              <br />
              ***: {i18n.t(['subscription', 'FRATips'])}
              <br />
              ****: {i18n.t(['subscription', 'chatTips'])}
              <br />
              <br />
              {'For large groups with more usage, please email '}
              <a href={`mailto:${i18n.t('iHealthCareEmail')}`}>{i18n.t('iHealthCareEmail')}</a>
              {' for price estimate.'}
            </div>)}
        />
      </div>
    );
  }
}

export default FeaturesView;



// WEBPACK FOOTER //
// ./src/components/subscription/FeaturesView.js